import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from '../../../Elements/Modal'
import Button from '../../../Formik/Button'
import AIGuidePaywall from './AIGuidePaywall'
import MainView from './MainView'

const CreateBudgetModal = () => {
  const { t } = useTranslation(['budget'])
  const [showModal, toggleModal] = useState(false)
  const [AIGuidePageNumber, setAIGuidePageNumber] = useState<null | number>(
    null,
  )

  return (
    <>
      <Modal
        show={showModal}
        onHide={() => {
          toggleModal(false)
          setAIGuidePageNumber(null)
        }}
        confirmClose={
          AIGuidePageNumber === 1
            ? t('budget:createBudgetModal.confirmClose')
            : undefined
        }
        wide
      >
        {AIGuidePageNumber === null && (
          <MainView startAIGuide={() => setAIGuidePageNumber(1)} />
        )}
        {AIGuidePageNumber === 1 && <AIGuidePaywall />}
      </Modal>
      <Button
        onClick={() => toggleModal(true)}
        className='ml-0 md:ml-2 mb-4 md:mb-0'
      >
        {t('budget:createBudgetModal.createButton')}
      </Button>
    </>
  )
}

export default CreateBudgetModal
